import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { getJson } from 'session';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import TagRequirements from './requirements/container/RequirementsTagging';
import ApplicationSettings from './application/container/ApplicationContainer';
import FeesContainer from './fees/container/FeesContainer';
// import OrdinanceRevisionContainer from './ordinanceRevision/container/OrdinanceRevisionContainer';

function SettingsContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/ebpls/settings/tag/requirements"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('ebpls/settings/tag/requirements') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Requirements Tagging
                </Link>
              </li>
            </ul>
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/ebpls/settings/application"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('ebpls/settings/application') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Application Settings
                </Link>
              </li>
            </ul>
            {Acl(permissions, ['EBPLS FEES SETTING']) && (
              <ul className="nav nav-tabs btn-settings-tab-container">
                <li className="nav-item">
                  <Link
                    to="/ebpls/settings/fees"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('ebpls/settings/fees') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Fees
                  </Link>
                </li>
              </ul>
            )}
            {/* <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/ebpls/settings/ordinance"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('ebpls/settings/ordinance') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Ordinance Revision
                </Link>
              </li>
            </ul> */}
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/tag/requirements`} />}
          />
          <Route
            path={`${match.path}/tag/requirements`}
            component={TagRequirements}
          />
          <Route
            path={`${match.path}/application`}
            component={ApplicationSettings}
          />
          {Acl(permissions, ['EBPLS FEES SETTING']) && (
            <Route path={`${match.path}/fees`} component={FeesContainer} />
          )}
          {/* <Route
            path={`${match.path}/ordinance`}
            component={OrdinanceRevisionContainer}
          /> */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  permissions: getJson('permissions'),
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsContainer);
